import Head from 'next/head'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

import Background from '~/components/Background'
import HubSpot from '~/components/HubSpot'
import OverlayContent from '~/components/OverlayContent'
import Body from '~/components/typography/Body'
import Bravo from '~/components/typography/Bravo'
import Charlie from '~/components/typography/Charlie'

export default function ReleaseNotes() {
  const router = useRouter()

  useEffect(() => {}, [])

  return (
    <Background>
      <Head>
        <title>Release notes | KwizzBit</title>
      </Head>
      <div className="container">
        <button
          className="flex items-center m-20 text-white"
          onClick={() => router.push('/login')}
        >
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
            <circle cx="15" cy="15" r="14" stroke="white" strokeWidth="2" />
            <path
              d="M17.2566 9.41082C17.582 9.73626 17.582 10.2639 17.2566 10.5893L12.8458 15.0001L17.2566 19.4108C17.582 19.7362 17.582 20.2639 17.2566 20.5893C16.9312 20.9147 16.4035 20.9147 16.0781 20.5893L11.0781 15.5893C10.7526 15.2639 10.7526 14.7362 11.0781 14.4108L16.0781 9.41082C16.4035 9.08539 16.9312 9.08539 17.2566 9.41082Z"
              fill="white"
            />
          </svg>
          <span className="ml-5">Back</span>
        </button>
      </div>
      <div className="flex flex-col justify-end md:justify-center flex-1 h-full">
        <OverlayContent wide>
          <Bravo>Release Notes</Bravo>
          <div className="mt-30 mb-40">
            <Charlie>
              Current Version 2.12.1{' '}
              <span className="text-sm-fluid">Released 29/09/2026</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>🆕 All new streamlined sign up process.</li>
                  <li>🪲 Fixed an issue with hosting some quizzes with misaligned questions.</li>
                  <li>
                    🪲 Fixed an issue when creating a new account using the email
                    address of a previously deleted account.
                  </li>
                  <li>🪲 Improved the error messages when signing up.</li>
                  <li>
                    🪲 Fixed an issue with dates showing as invalid on the past
                    quizzes page.
                  </li>
                  <li>
                    🪲 Fixed an issue for Startle venue users when connecting to
                    Startle.
                  </li>
                  <li>
                    🪲 Fixed an issue where previously subscribed users saw an
                    error instead of plan prices when re-subscribing.
                  </li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">LIVE QUIZZES</Body>
                <ul className="ml-10">
                  <li>
                    🆕 Players can now rejoin a quiz and carry on with their
                    score intact — logged-in players from any device.
                  </li>
                  <li>
                    🆕 Accounts are now protected in live games: only one
                    device can play per account at a time, and joining a quiz
                    that doesn&apos;t allow guests requires being logged in.
                  </li>
                  <li>
                    🪲 Fixed an issue where KwizzBit Live players could
                    randomly lose their venue and appear as N/A on leaderboards
                    and reports.
                  </li>
                  <li>
                    🪲 Fixed an issue where answer scores could be lost if the
                    realtime connection hiccuped.
                  </li>
                  <li>
                    🪲 Fixed an issue where the PIN of a deleted quiz could
                    still appear joinable.
                  </li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">QUIZ BUILDER</Body>
                <ul className="ml-10">
                  <li>
                    🪲 Fixed an issue when saving quizzes with some optional
                    values left empty.
                  </li>
                  <li>🪲 Fixed an issue with editing some older quizzes.</li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.12.0{' '}
              <span className="text-sm-fluid">Released 18/08/2026</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>🪲 Some memory leaks fixed in startle Live events.</li>
                  <li>🪲 Hubspot upgraded.</li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.11.13{' '}
              <span className="text-sm-fluid">Released 04/07/2026</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>🆕 Walkthrough introduced</li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.11.12{' '}
              <span className="text-sm-fluid">Released 26/05/2026</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>🆕 Demo account introduced</li>
                  <li>🪲 Fixed issue when trying to reset password.</li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.11.11{' '}
              <span className="text-sm-fluid">Released 18/03/2026</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>🆕 Instant win for solo games introduced.</li>
                  <li></li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">GAMEPLAY</Body>
                <ul className="ml-10">
                  <li>🆕 White labelling added on quizzes.</li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.11.10{' '}
              <span className="text-sm-fluid">Released 14/01/2026</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>
                    🪲 Fixed issue when registering no more duplicated account
                    attempts.
                  </li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">QUIZ BUILDER</Body>
                <ul className="ml-10">
                  <li>🆕 Ability to top up your quizzes with ai content.</li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.11.9{' '}
              <span className="text-sm-fluid">Released 11/12/2025</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>🆕 Startle integration improvements.</li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">QUIZ PLAY</Body>
                <ul className="ml-10">
                  <li>🪲 Fixed issue with previous round name flashing up.</li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">QUIZ BUILDER</Body>
                <ul className="ml-10">
                  <li>
                    🪲 Made the search bar focused when searching for questions.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.11.8{' '}
              <span className="text-sm-fluid">Released 31/07/2025</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>
                    🪲 Fixed issue in the trial payment process with email
                    communications.
                  </li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">QUIZ PLAY</Body>
                <ul className="ml-10">
                  <li>
                    🪲 Fixed issue with the auto play not working at certain
                    breakpoints.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.11.7{' '}
              <span className="text-sm-fluid">Released 10/07/2025</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GAME PLAY</Body>
                <ul className="ml-10">
                  <li>
                    ⚙️ Solo Play quizzes now have all of the question types.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.11.6{' '}
              <span className="text-sm-fluid">Released 19/06/2025</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>
                    ⚙️ Improved user experience on the subscriptions page.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.11.5{' '}
              <span className="text-sm-fluid">Released 15/05/2025</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>🆕️ Added new three month trial payment.</li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.11.4{' '}
              <span className="text-sm-fluid">Released 03/04/2025</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">QUIZ PLAY</Body>
                <ul className="ml-10">
                  <li>⚙️ Player name profanity filter adjustments.</li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.11.3_1{' '}
              <span className="text-sm-fluid">Released 04/03/2025</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>
                    🆕 Auto play quizzes introduced. The ability to play a quiz
                    without a host.
                  </li>
                  <li>
                    ⚙️ Changed the pricing structure, enhanced the pro account.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.11.2{' '}
              <span className="text-sm-fluid">Released 04/02/2025</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>
                    🆕 Offline quizzes introduced. The ability to print our
                    quizzes.
                  </li>
                  <li>
                    🆕 Toggle on the dashboard for "My quizzes" and "Past hosted
                    quizzes" added.
                  </li>
                  <li>
                    🪲 Fixed missing link to leaderboard on the past quizzes
                    page.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.11.1{' '}
              <span className="text-sm-fluid">Released 27/01/2025</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>🆕 Startle integration.</li>
                  <li>🪲 Fixed issue with stopping stream.</li>
                  <li>
                    🪲 Fixed issue with players not always having host type.
                  </li>
                  <li>🪲 Fixed some styling inconsistencies around the site.</li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">QUIZ PLAY</Body>
                <ul className="ml-10">
                  <li>
                    ⚙️ Changed the start quiz button look and feel to make it
                    more intuitive.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.11.0{' '}
              <span className="text-sm-fluid">Released 05/11/2024</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>🆕 All new dashboard experience.</li>
                  <li>⚙️ Changes to the free subscription plan.</li>
                  <li>
                    ⚙️ Subscriptions with access to leagues no longer have a
                    limit on how many they can create.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.10.6{' '}
              <span className="text-sm-fluid">Released 13/08/2024</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>🆕 All new registration process.</li>
                  <li>
                    🆕 Capturing host type for an improved personalisation
                    experience.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.10.5{' '}
              <span className="text-sm-fluid">Released 09/07/2024</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">QUIZ PLAY</Body>
                <ul className="ml-10">
                  <li>🆕 Fifty fifty question type added.</li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.10.4{' '}
              <span className="text-sm-fluid">Released 23/05/2024</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>🆕 Added KwizzBit Solo Play version 2.</li>
                  <li>🆕 Added more analytics to the site.</li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">QUIZ PLAY</Body>
                <ul className="ml-10">
                  <li>
                    🪲 Fixed issue when players are joining KwizzBit Live games
                    without a venue.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.10.3{' '}
              <span className="text-sm-fluid">Released 24/04/2024</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>
                    🪲 Fixed issue when payment fails you cannot change details
                    and continue.
                  </li>
                  <li>
                    🪲 Fixed issue with the labels when scheduling a quiz in
                    Safari.
                  </li>
                  <li>
                    🪲 Fixed issue when showing the league table when a player
                    has deleted their account.
                  </li>
                  <li>⚙️ Changed copy when adding a quiz to a league.</li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">QUIZ PLAY</Body>
                <ul className="ml-10">
                  <li>
                    🪲 Fixed issue with leaderboard cut off at the end of quiz at
                    certain screen sizes.
                  </li>
                  <li>
                    🪲 Fixed issue when joining game, having to type the pin in
                    twice.
                  </li>
                  <li>
                    🪲 Fixed issue with leaderboard cut off at the end of quiz at
                    certain screen sizes.
                  </li>
                  <li>
                    🪲 Fixed issue when joining game, having to type the pin in
                    twice.
                  </li>
                  <li>🪲 Fixed alignment issues on end of game screen.</li>
                  <li>⚙️ Changed the copy at the end of the quiz.</li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">QUIZ BUILDER</Body>
                <ul className="ml-10">
                  <li>
                    🪲 Fixed issue where the picture numerical questions do not
                    show.
                  </li>
                  <li>
                    🪲 Fixed issue with the back button on the quiz builder, this
                    now takes the user back to the correct page.
                  </li>
                  <li>
                    🪲 Fixed issue with the answers not having whitespace trimmed
                    properly.
                  </li>
                  <li>
                    ⛔️ Removed ability to create answers with a space at the
                    end of the answer.
                  </li>
                  <li>
                    🪲 Fixed issue where the picture numerical questions do not
                    show.
                  </li>
                  <li>
                    🪲 Fixed issue with the back button on the quiz builder, this
                    now takes the user back to the correct page.
                  </li>
                  <li>
                    🪲 Fixed issue with the answers not having whitespace trimmed
                    properly.
                  </li>
                  <li>
                    ⛔️ Removed ability to create answers with a space at the
                    end of the answer.
                  </li>
                  <li>⚙️ Updated the delete question modal.</li>
                  <li>🆕 Added more detail to the question view.</li>
                  <li>
                    🆕 Added a new button when creating a question to "Save and
                    add another question".
                  </li>
                  <li>
                    🆕 Added a new button when creating a question to "Save and
                    add another question".
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.10.2{' '}
              <span className="text-sm-fluid">Released 04/12/2023</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>
                    🪲 Fixed issue with the scoring for venues in KwizzBit Live
                    quizzes.
                  </li>
                  <li>
                    🪲 Fixed issue with the scoring for venues in KwizzBit Live
                    quizzes.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.10.1{' '}
              <span className="text-sm-fluid">Released 18/10/2023</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>
                    🪲 Fixed error when trying to load Leagues page when not
                    logged in.
                  </li>
                  <li>
                    🪲 Fixed error when trying to load Leagues page when not
                    logged in.
                  </li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">QUIZ PLAY</Body>
                <ul className="ml-10">
                  <li>
                    🪲 Fixed issue with background music stopping game play on
                    host side in certain versions of Safari.
                  </li>
                  <li>
                    🪲 Fixed issue when access to camera is denied and the host
                    tries to stop stream.
                  </li>
                  <li>
                    🪲 Fixed issue when players rejoin a game and get a blank
                    screen.
                  </li>
                  <li>
                    ⛔️ Removed one version of the confetti when player answers
                    correct. This is due to it causing errors in game play.
                  </li>
                  <li>
                    🪲 Fixed issue with background music stopping game play on
                    host side in certain versions of Safari.
                  </li>
                  <li>
                    🪲 Fixed issue when access to camera is denied and the host
                    tries to stop stream.
                  </li>
                  <li>
                    🪲 Fixed issue when players rejoin a game and get a blank
                    screen.
                  </li>
                  <li>
                    ⛔️ Removed one version of the confetti when player answers
                    correct. This is due to it causing errors in game play.
                  </li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">QUIZ BUILDER</Body>
                <ul className="ml-10">
                  <li>
                    🪲 Stopped users being able to continue with the quiz
                    creation until the image is uploaded, if one is used.
                  </li>
                  <li>
                    🪲 Stopped users being able to continue with the quiz
                    creation until the image is uploaded, if one is used.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.10.0{' '}
              <span className="text-sm-fluid">Released 11/10/2023</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>
                    🪲 Fixed the load more results link on the My past quizzes
                    page.
                  </li>
                  <li>
                    🪲 Fixed the load more results link on the My quizzes page.
                  </li>
                  <li>
                    ⚙️ Changed the default button for the My details page form.
                  </li>
                  <li>
                    🪲 Fixed the load more results link on the My past quizzes
                    page.
                  </li>
                  <li>
                    🪲 Fixed the load more results link on the My quizzes page.
                  </li>
                  <li>
                    ⚙️ Changed the default button for the My details page form.
                  </li>
                  <li>🆕 KwizzBit Play added to the system.</li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.9.1{' '}
              <span className="text-sm-fluid">Released 20/09/2023</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>🪲 Fixed issue with end game link not appearing.</li>
                  <li>🎨 Corrected font colour on the view quiz page.</li>
                  <li>
                    ⛔️ Removed redundant title if no quiz description on the
                    view quiz page.
                  </li>
                  <li>🆕 New enterprise features.</li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">QUIZ PLAY</Body>
                <ul className="ml-10">
                  <li>🪲 Fixed the guest play functionality.</li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">QUIZ BUILDER</Body>
                <ul className="ml-10">
                  <li>
                    🆕 Additional question insight data added for questions.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.9.0{' '}
              <span className="text-sm-fluid">Released 30/08/2023</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>
                    🪲 Scheduled time on the view quiz page corrected to 24 hour
                    clock.
                  </li>
                  <li>🆕 Added past quizzes landing page.</li>
                  <li>🆕 Added host name to quiz card.</li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">QUIZ BUILDER</Body>
                <ul className="ml-10">
                  <li>
                    🪲 Fixed issue with picture correct order question type not
                    shuffling answers.
                  </li>
                  <li>
                    🆕 Ability to create and compile quizzes from our existing
                    quizzes in the system.
                  </li>
                  <li>🆕 Insight data capture added for quiz questions.</li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">QUIZ PLAY</Body>
                <ul className="ml-10">
                  <li>🪲 Fixed the tension music when showing questions.</li>
                  <li>🆕 Ability to remove guest play from quizzes.</li>
                  <li>🆕 Added new music question type for 2 from 4.</li>
                  <li>🆕 Added new music question type for numerical.</li>
                  <li>🆕 Added new music question type for correct order.</li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.8.1{' '}
              <span className="text-sm-fluid">Released 03/07/2023</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">QUIZ BUILDER</Body>
                <ul className="ml-10">
                  <li>
                    🪲 Fixed issue with not being able to see all of the quizzes
                    for certain accounts.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.8.0{' '}
              <span className="text-sm-fluid">Released 29/06/2023</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>🆕 KwizzBit Music added to the system.</li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">QUIZ BUILDER</Body>
                <ul className="ml-10">
                  <li>⚙️ Refactored the quiz builder experience.</li>
                  <li>
                    🆕 Added new question type for picture 2 from 4 to the quiz
                    builder.
                  </li>
                  <li>
                    🆕 Added new question type for picture numerical to the quiz
                    builder.
                  </li>
                  <li>
                    🆕 Added new question type for picture correct order to the
                    quiz builder.
                  </li>
                  <li>🆕 Added ability to remove a whole round from a quiz.</li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">QUIZ PLAY</Body>
                <ul className="ml-10">
                  <li>⚙️ Pre-loaded quiz images for smoother gameplay.</li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.7.0{' '}
              <span className="text-sm-fluid">Released 06/06/2023</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>
                    🪲 Fixed issue with scores being calculated twice on end
                    game.
                  </li>
                  <li>🆕 KwizzBit Leagues added to the system.</li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.6.1{' '}
              <span className="text-sm-fluid">Released 31/05/2023</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>
                    🪲 Fixed issue with the venue stream not starting correctly
                    on KwizzBit Live.
                  </li>
                  <li>
                    🪲 Fixed issue with the venue scoring on KwizzBit Live.
                  </li>
                  <li>
                    🪲 Fixed issue with certain pages across the website not
                    being able to refresh page.
                  </li>
                  <li>
                    ⚙️ Increased the stream quality for KwizzBit Live quizzes.
                  </li>
                  <li>
                    🆕 Reconnect to stream button added upon refresh of the
                    KwizzBit Live venue page.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.6.0{' '}
              <span className="text-sm-fluid">Released 03/05/2023</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>🆕 KwizzBit Live added to the system.</li>
                  <li>🆕 Added release notes page.</li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">QUIZ BUILDER</Body>
                <ul className="ml-10">
                  <li>
                    🪲 Fixed issue with picture question which would allow you to
                    save without a correct answer.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.5.1{' '}
              <span className="text-sm-fluid">Released 28/03/2023</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>🪲 Main navigation fades in once loaded correctly.</li>
                  <li>
                    🪲 Fixed issue with the "Let's get started" modal jumping
                    when loaded.
                  </li>
                  <li>
                    ⚙️ Moved the position of the "Let's get started" modal when
                    clicking create new quiz for desktop.
                  </li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">QUIZ BUILDER</Body>
                <ul className="ml-10">
                  <li>
                    🪲 Fixed issue where the text cursor would move to the end of
                    the text box when editing an answer.
                  </li>
                  <li>
                    🪲 Added better error messaging on image upload issues.
                  </li>
                  <li>
                    🪲 Fixed incorrect second round page layout when refreshing
                    the quiz builder.
                  </li>
                  <li>
                    🪲 Fixed issue with the answers not loading when editing a
                    picture question.
                  </li>
                  <li>
                    🪲 Fixed issue with not being able to edit a picture
                    questions image.
                  </li>
                  <li>
                    🪲 Fixed issue with correct order question answers not
                    re-shuffling on browser back button.
                  </li>
                  <li>
                    🪲 Fixed issue where creating a new quiz and then cancelling
                    the newly created quiz, if you then start to create a new
                    quiz the questions from the cancelled quiz would appear.
                  </li>
                  <li>
                    🪲 Fixed issue with error states on the picture question not
                    being shown immediately.
                  </li>
                  <li>
                    🪲 Fixed issue with error state not being removed when the
                    question is removed from the quiz.
                  </li>
                  <li>
                    🪲 Fixed issue with error states not being visible in any
                    round other than round one.
                  </li>
                  <li>
                    🪲 Fixed issue when dragging questions around the quiz would
                    not allow you to edit the same question.
                  </li>
                  <li>
                    🪲 Fixed issue with correct order questions failing. When
                    changing the question type to a correct order from another
                    question type the question would fail when playing the quiz.
                  </li>
                  <li>
                    ⛔️ Removed image when saving image after swapping question
                    type.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.5.0{' '}
              <span className="text-sm-fluid">Released 27/02/2023</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">QUIZ BUILDER</Body>
                <ul className="ml-10">
                  <li>
                    🆕 Added the ability to create quizzes with a double point
                    question.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.4.0{' '}
              <span className="text-sm-fluid">Released 06/02/2023</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>⚙️ Updated copy for transactional emails.</li>
                  <li>
                    🆕 Added the ability to buy KwizzBit for just one month.
                  </li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">GAMEPLAY</Body>
                <ul className="ml-10">
                  <li>
                    ⚙️ Minor changes to the profanity filter for player names.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30 mb-40">
            <Charlie>
              Version 2.3.0{' '}
              <span className="text-sm-fluid">Released 06/12/2022</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>
                    ⛔️ Removed the next invoice date on the checkout page.
                  </li>
                  <li>
                    ⛔️ Removed the quiz rating panel after a quiz has ended.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-30">
            <Charlie>
              Version 2.2.0{' '}
              <span className="text-sm-fluid">Released 24/10/2022</span>
            </Charlie>
            <div className="ml-10">
              <div className="mt-20">
                <Body className="mb-8">GENERAL</Body>
                <ul className="ml-10">
                  <li>
                    ⛔️ Removed the links to the old website on the login and
                    sign-up pages.
                  </li>
                  <li>
                    🆕 Added a new backlink at the top of the category pages.
                  </li>
                  <li>
                    🆕 Added the ability to use coupons when signing up for a
                    subscription or changing a subscription.
                  </li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">QUIZ BUILDER</Body>
                <ul className="ml-10">
                  <li>
                    🪲 Correct order question answers would reset to the correct
                    order if you closed the question by clicking ‘close’.
                  </li>
                  <li>
                    🆕 Added a total count of questions when editing or creating
                    a quiz.
                  </li>
                </ul>
              </div>
              <div className="mt-30">
                <Body className="mb-8">GAMEPLAY</Body>
                <ul className="ml-10">
                  <li>
                    ⛔️ Removed the picture from the player's screen when they
                    are looking at the answers.
                  </li>
                  <li>
                    🆕 Added the tension music into the game with the ability to
                    mute and unmute.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </OverlayContent>
      </div>
      <HubSpot page={'release-notes/'} />
    </Background>
  )
}
